module.exports = __webpack_public_path__ + "img/figure-6.e96396cb.png";